import { AmlFlowEnum } from "@/config";

export const isFlowLimited = (flow: AmlFlowEnum | "") => {
  if (!flow) {
    return false;
  }

  return (
    [
      AmlFlowEnum.LITE,
      AmlFlowEnum.LIGHT,
      AmlFlowEnum.FAST_LIMITED,
      AmlFlowEnum.ADVANCED_LIMITED,
    ] as AmlFlowEnum[]
  ).includes(flow);
};
